/**
 * For maintainability we should separate controllers into their own modules
 */
angular.module('acme.view.application.passes.create.modals.publish.controllers', [
  'ui.bootstrap'
])

.controller('PassesCreateModalsPublishController', ['$scope', '$uibModalInstance', function($scope, $uibModalInstance) {

    $scope.passesCreateModalsPublish = {

      model: "Your spankin new application.passes.create.modals.publish view!",

      init: function() {},

      confirm: function () {
        $uibModalInstance.close(true);
      },

      cancel: function () {
        $uibModalInstance.dismiss();
      },

      success: {
        init: function(response) {}
      },

      error: {
        init: function(response) {}
      }

    };

    $scope.passesCreateModalsPublish.init();

}]);